import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function sliderQuotations() {
  document.addEventListener('DOMContentLoaded', function () {

    if (document.querySelector('.quotations-slider')) {
  
      var sliderQuotations = new Splide('.quotations-slider', {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        autoplay: false,
        interval: 5500,
        pagination: false,
        arrows: true,
        gap: 16

      });

      sliderQuotations.on('mounted', () => {
        if (sliderQuotations.length <= sliderQuotations.options.perPage) {
          sliderQuotations.options = {
            arrows: false,
            pagination: false,
            drag: false
          };
          sliderQuotations.destroy();
          sliderQuotations.mount();
        }
      })

      sliderQuotations.mount();
    }

  });
}

